export default [
  { id: 0, name: 'VENTA' },
  { id: 1, name: 'RECOMPRA' },
  { id: 2, name: 'RESCILIACION' },
  { id: 3, name: 'SWAP' }
];
